import { ErrorsOr } from "@me8eon/errors";

export type AppendAsyncStore<Id, Child> = {
    append: (id: Id, ...ts: Child[]) => Promise<ErrorsOr<void>>;
}

/** The contract is that this might return a default T or errors when id doesn't exist. That is implementation specific */
export type GetAsyncStore<Id, T> = {
    get: (id: Id, undefinedIfNotIn?: boolean) => Promise<ErrorsOr<T>>
}

export type StoreAsyncStore<Id, T> = {
    store: (id: Id, t: T) => Promise<ErrorsOr<void>>
}

export type DeleteAsyncStore<Id> = {
    delete: (...ids: Id[]) => Promise<ErrorsOr<void>>
}
export type StoreGetAsyncStore<Id, T> = GetAsyncStore<Id, T> & StoreAsyncStore<Id, T>

export type AsyncStore<Id, T> = StoreGetAsyncStore<Id, T> & DeleteAsyncStore<Id>

export type AppendAndGetAsyncStore<Id, T> = GetAsyncStore<Id, T[]> & AppendAsyncStore<Id, T>

export function defaultRandomId(): string {
    return Math.random().toString(36).substring(2, 15);
}
